import {
  Box,
  Button,
  FormLabel,
  Heading,
  HStack,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../components/Models/main-model";
import { closeRefuseHomeworkModel } from "../../../modules/admin-modules/models/Actions";
import {
  commentStuentHomeworkRequest,
  deleteStuentHomeworkRequest,
} from "../../../modules/superadmin-modules/reports/Actions";
const HomeworkRefuseComment = ({ data, homeworkId }) => {
  const baseUrl = "https://api.agwad.net/public/uploads/";

  const openHomeworkComment = useSelector((state) => state.model.isOpen32);
  const [comment, setComment] = useState("");
  const dispatch = useDispatch();
  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px"></Heading>
    </Box>
  );
  const handelAddComment = async () => {
    await dispatch(
      commentStuentHomeworkRequest({
        id: data?.id,
        body: {
          student_homework_id: data?.id,
          student_id: data?.student?.id,
          evaluation: comment,
        },
      })
    );
    setTimeout(() => {
      dispatch(
        deleteStuentHomeworkRequest(data?.id)
      );
    }, 1500);
    dispatch(closeRefuseHomeworkModel());
  };
  const closeFunc = () => {
    dispatch(closeRefuseHomeworkModel());
  };

  const setEvalation = (evalation) => () => {
    setComment(evalation);
    // set the text area value to the evalation
    document.getElementById("homework").value = evalation;
  };
  return (
    <MainModel
      isLoading={false}
      header={header}
      closeFunc={closeFunc}
      openVar={openHomeworkComment}
      buttonTitle={"حفظ التغيرات"}
      buttonFunc={handelAddComment}
    >
      <VStack dir="rtl">
        <HStack w="100%">
          <FormLabel> الطالب : {data?.student?.name} </FormLabel>
          <FormLabel> الواجب : {data?.homework?.name} </FormLabel>
          <Button
            as="a"
            href={`https://docs.google.com/gview?url=${baseUrl}${data?.file}`}
            target="_blank"
          >
            الحل
          </Button>
        </HStack>

        <HStack w="100%">
          <Button
            onClick={setEvalation(
              "Your homework is refused due to missing steps, please complete your steps and upload it again"
            )}
          >
            الخطوات ناقصة
          </Button>
          <Button
            onClick={setEvalation(
              "Your homework is refused because there are many wrong questions, please review your HW using the HW Video and upload it again"
            )}
          >
            الحل غير صحيح
          </Button>
          <Button
            onClick={setEvalation(
              "Your homework is refused due to missing questions, please complete your HW and upload it again"
            )}
          >
            الحل غير مكتمل
          </Button>
          <Button
            onClick={setEvalation(
              "Your homework is refused because you uploaded the wrong HW PDF, please upload the correct HW PDF"
            )}
          >
            الملف الخاطئ
          </Button>
        </HStack>
        <Box w="100%">
          <FormLabel> الملاحظات : </FormLabel>
          <Textarea
            bg="#f5f5f5"
            placeholder="اكتب الملاحظات"
            onChange={(e) => setComment(e.target.value)}
            name="homework"
            id="homework"
          ></Textarea>
        </Box>
      </VStack>
    </MainModel>
  );
};

export default HomeworkRefuseComment;
